// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"input_inputWrapper__whEGi","error":"input_error__vY_tX"};